import React, { useState, useEffect, useCallback} from "react";
import esriConfig from "@arcgis/core/config";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import Search from "@arcgis/core/widgets/Search";
import LayerSearchSource from "@arcgis/core/widgets/Search/LayerSearchSource";
import { debounce } from "lodash";


export default function SearchArcgis(props) {
  const [searchBoxes, setSearchBoxes] = useState([]);
  const [inputFields, setInputFields] = useState({});
  const [clearing, setClearing] = useState(true)
  // const [isSearching, setIsSearching] = useState(false);
  // create defualt search state based on searchType object's "joins" attributes
  /*
  [
    ['street_number', ''],
    ['street_name', '']
  ]
  */

// when there is a new search type
  useEffect(() => {
    setClearing(true)
    esriConfig.apiKey = 'AAPK62daac607e3a40e58c9cb76c8412103bLVg4fLW_SF3o2d5z95L5PNemEaRIz6Kxk1K8GNpmykKl84zBrSADiPaiT0LRKbLK';
    const featureLayer = new FeatureLayer({
      url: props.searchManager.getAPI(props.searchType),
      outFields: props.searchManager.getOutFields(props.searchType),
      definitionExpression: props.searchManager.getDefinitionExpression(props.searchType)
    });
    const src = new LayerSearchSource({
      layer: featureLayer,
      searchFields: props.searchManager.getSearchFields(props.searchType),
      displayField: props.searchManager.getSearchFields(props.searchType)[0],
      exactMatch: false,
      outFields: props.searchManager.getOutFields(props.searchType),
      suggestionTemplate: props.searchManager.getSearchTemplate(props.searchType),
      maxSuggestions: 25,
      minSuggestCharacters: 2,
    })
    const sw = new Search({
      allPlaceholder: 'Search',
      includeDefaultSources: false,
      sources: [src]
    });
    props.setSearchWidget(sw)
    // eslint-disable-next-line
  }, [props.searchType])

// if needs to be cleared
  useEffect(() => {
    //Generate empty input field object
    //Clearing Value Changed. Seeing if clearing
    if (clearing) {
      //Clearing. Refreshing Fields.
      const searchFields = {[`${props.searchManager.getSearchFields(props.searchType)[0]}`]:''};
      setInputFields(searchFields);
      setClearing(false);
      //Stopped Clearing. Fields Refreshed
    }
    // eslint-disable-next-line
  }, [clearing])

function getSuggestions(input){

  props.searchWidget.suggest(input)
      .then(response => {
        props.setSuggestions(response);
        props.setRequestLoading(false);
      })
}
const debouncedGetSuggestions = debounce(getSuggestions, 500)



// if search widget changes
  const handleSuggest = useCallback((e) => {
    // update search box
    setInputFields({[`${e.target.name}`]: e.target.value});
    props.setResults([]); 
    props.setAddress(null);
    props.setRequestLoading(true);
    // get suggestions
    debouncedGetSuggestions(e.target.value)
    // eslint-disable-next-line
  }, [props.searchWidget])

  

// if done clearing
  useEffect(() => {
    //Clearing Value Changed. Seeing if clearing
    if (!clearing) {
      //Generate inputs
      //Not Clearing. Generating Fields
      const sb = props.searchManager.getSearchFieldMap(props.searchType).map((j, i) => {
        return (
          <div key={i}>
            <input className="shadow" type="text" name={j.field} value={inputFields[j.field]} onChange={e => handleSuggest(e)} />
            <div className="pt-4 text-sm md:text-base md:w-1/2 md:mx-auto">{j.instructions}</div>
          </div>
        )
      });
      setSearchBoxes(sb);
    }
    // eslint-disable-next-line
  }, [clearing, inputFields])


  return (
    searchBoxes &&
    <div className='w-full p-2.5'>
      <div className='py-4 mx-auto'>
      {searchBoxes}
      </div>
    </div>
  )
}